// V3ClipboardCell.jsx
import React, { useState } from "react";

import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { ContentCopyRounded as CopyIcon } from "@mui/icons-material";
import { Check as CheckIcon } from "@mui/icons-material";
import { v3Theme } from '../theme';

const V3ClipboardCell = ({ text }) => {
    const [copied, setCopied] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(text).then(() => {
            console.log("Copied to clipboard:", text);
            setCopied(true);
            setOpenSnackbar(true);

            // Через 2 секунды возвращаем иконку и скрываем Snackbar
            setTimeout(() => {
                setCopied(false);
                setOpenSnackbar(false);
            }, 2000);
        });
    };

    return (
        <>
            <Box
                component="form"
                sx={{ p: 0, display: 'flex', alignItems: 'center' }}
            >
                <TextField
                    defaultValue={text}
                    size="small"
                    sx={{ 
                        p: 0,
                        '& .MuiOutlinedInput-root': {
                            color: v3Theme.text.primary,
                            fontFamily: v3Theme.typography.fontFamily,
                            '& fieldset': {
                                borderColor: v3Theme.main,
                                borderWidth: 2,
                            },
                            '&:hover fieldset': {
                                borderColor: v3Theme.main,
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: v3Theme.main,
                            },
                        },
                    }}
                />

                <IconButton
                    sx={{ 
                        p: 1,
                        color: v3Theme.main,
                        '&:hover': {
                            backgroundColor: `${v3Theme.main}10`,
                        }
                    }}
                    aria-label="copy"
                    onClick={handleCopy}
                >
                    {copied ? <CheckIcon /> : <CopyIcon />}
                </IconButton>
            </Box>

            <Snackbar
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                autoHideDuration={2000}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                    Copied to clipboard: {text}
                </Alert>
            </Snackbar>
        </>
    );
};

export default V3ClipboardCell;